import { Button, message } from 'antd';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IVerificationCode, ResetByMobile, ResetByEmail } from 'src/entity/LoginParam';
import I18N from 'src/services/I18NService';
import LoginService from 'src/services/LoginService';
import { UtilRegExp } from 'src/utils/regExp';

interface IVerificationCodeProps extends RouteComponentProps {
  isDomestic: boolean;
  /**
   * isDomestic=true时，phoneOrEmail表示手机号，否则表示邮箱
   *
   * @type {string}
   * @memberof IVerificationCodeProps
   */
  phoneOrEmail: string;
}

class VerificationCodeButton extends React.Component<IVerificationCodeProps> {
  constructor(props: IVerificationCodeProps) {
    super(props);
  }

  timer: any;
  counter: any;
  timeout: number = 60 * 1000;
  state = {
    timerCount: this.timeout / 1000,
    showTimer: false,
    showText: I18N.get('login_get_verify'),
    canDisabled: false,
  };

  componentWillUnmount() {
    if (!!this.timer) {
      clearTimeout(this.timer);
    }
    if (!!this.counter) {
      clearInterval(this.counter);
    }
    this.setState = () => {
      return;
    };
  }

  handleVerify = async () => {
    try {
      const { phoneOrEmail, isDomestic } = this.props;
      if (!!isDomestic) {
        if (!UtilRegExp.isPhone(phoneOrEmail)) {
          message.error(I18N.get('err_mobile'));
          return;
        }
        const data: IVerificationCode = {
          mobile: phoneOrEmail,
        };
        await LoginService.sendVerifyCode(data, ResetByMobile);
      } else {
        if (!UtilRegExp.isEmail(phoneOrEmail)) {
          message.error(I18N.get('err_email'));
          return;
        }
        const data: IVerificationCode = {
          email: phoneOrEmail,
        };
        await LoginService.sendVerifyCode(data, ResetByEmail);
      }
      this.setState({
        canDisabled: true,
        showTimer: true,
        showText: I18N.get('login_reset_verify'),
      });
      this.counter = setInterval(() => {
        const timerCount = this.state.timerCount - 1;
        this.setState({
          timerCount,
        });
      }, 1000);
      this.timer = setTimeout(() => {
        this.setState({
          timerCount: this.timeout / 1000,
          canDisabled: false,
          showTimer: false,
          showText: I18N.get('login_get_verify'),
        });
        clearInterval(this.counter);
      }, this.timeout);
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_verify_failure'));
      }
    }
  };

  render() {
    return (
      <Button type="primary" disabled={this.state.canDisabled} onClick={this.handleVerify}>
        {this.state.showTimer && <span>{this.state.timerCount}</span>}
        {this.state.showText}
      </Button>
    );
  }
}

export default withRouter(VerificationCodeButton);



// WEBPACK FOOTER //
// ./src/components/common/VerificationCodeButton.tsx